import type { AgentStudioNavigation } from 'studio5/lib/agent-studio-link-outs';
import { resolveAgentStudioNavigation } from 'studio5/lib/agent-studio-link-outs';
import useFeature from './use-feature';

export default function useAgentStudioNavigation(
  pathname: string
): AgentStudioNavigation {
  // Always read every flag: useFeature only reads its argument on mount, so
  // gating by route would break client-side navs, and a flag that turns on
  // later can't swap a page mid-edit.
  const hasAgentStudio = useFeature('AGENT_STUDIO');
  const hasAgentStudioAudiences = useFeature('AGENT_STUDIO_AUDIENCES');
  const hasNps2 = useFeature('NPS_2_0');

  return resolveAgentStudioNavigation(pathname, {
    AGENT_STUDIO: hasAgentStudio,
    AGENT_STUDIO_AUDIENCES: hasAgentStudioAudiences,
    NPS_2_0: hasNps2,
  });
}
